(function () {
  if (window.StackPayCheckout && window.StackPayCheckout.__loaded === true) {
    if (typeof window.StackPayCheckout.installButton === "function") {
      window.setTimeout(window.StackPayCheckout.installButton, 100);
    }
    return;
  }

  window.StackPayScriptLoadedAt = new Date().toISOString();
  window.StackPayScriptVersion = "shopify-cart-drawer-28";

  function getScriptElement() {
    if (
      document.currentScript &&
      document.currentScript.src &&
      document.currentScript.src.indexOf("stackpay-shopify-cart") !== -1
    ) {
      return document.currentScript;
    }

    var scripts = Array.prototype.slice.call(
      document.querySelectorAll('script[src*="stackpay-shopify-cart"]'),
    );
    return scripts[scripts.length - 1] || document.currentScript;
  }

  var script = getScriptElement();
  var windowConfig = window.StackPayConfig || {};
  var baseUrl =
    script && script.dataset && script.dataset.stackpayBase
      ? script.dataset.stackpayBase
      : windowConfig.baseUrl || "";
  var configuredShop =
    script && script.dataset && script.dataset.stackpayShop
      ? script.dataset.stackpayShop
      : windowConfig.shop || "";
  var configuredMerchant =
    script && script.dataset && script.dataset.stackpayMerchant
      ? script.dataset.stackpayMerchant
      : windowConfig.merchantId || windowConfig.merchant || "";
  var debug =
    script && script.dataset && script.dataset.stackpayDebug
      ? script.dataset.stackpayDebug === "1"
      : windowConfig.debug === true || windowConfig.debug === "1";
  var configuredLabel =
    script && script.dataset && script.dataset.stackpayLabel
      ? script.dataset.stackpayLabel
      : windowConfig.label || "";
  var fallbackMode =
    script && script.dataset && script.dataset.stackpayFallback
      ? script.dataset.stackpayFallback
      : windowConfig.fallback || "alert";
  var productFallbackMode =
    script && script.dataset && script.dataset.stackpayProductFallback
      ? script.dataset.stackpayProductFallback
      : windowConfig.productFallback || "alert";
  var nativeCheckoutUrl =
    script && script.dataset && script.dataset.stackpayNativeCheckout
      ? script.dataset.stackpayNativeCheckout
      : windowConfig.nativeCheckoutUrl || "/checkout";
  var directBuyEnabled =
    script && script.dataset && script.dataset.stackpayDirectBuy
      ? script.dataset.stackpayDirectBuy === "1"
      : windowConfig.directBuy === true || windowConfig.directBuy === "1";
  var activeButton = null;
  var redirecting = false;
  var observerTimer = null;
  var productCache = {};
  var drawerState = {
    open: false,
    loading: false,
    cart: null,
    config: null,
    error: null,
  };
  var drawerElements = null;
  var checkoutFeatureEnabled = false;
  var checkoutFeatureKnown = false;
  var drawerFeatureEnabled = false;
  var drawerFeatureKnown = false;

  var DEFAULT_DRAWER_CUSTOMIZATION = {
    is_enabled: false,
    title: "Seu carrinho",
    subtitle: "Revise seus produtos antes de finalizar a compra.",
    checkout_button_text: "Finalizar compra",
    continue_shopping_text: "Continuar comprando",
    empty_cart_text: "Seu carrinho esta vazio.",
    primary_color: "#0F172A",
    button_color: "#10B981",
    background_color: "#FFFFFF",
    text_color: "#0F172A",
    accent_color: "#6366F1",
    border_radius: 16,
    show_free_shipping_progress: true,
    free_shipping_threshold_cents: null,
    show_order_bumps: true,
    show_gifts: true,
    custom_css: "",
  };

  function log() {
    if (!debug || !window.console) return;
    console.log.apply(console, ["[StackPay]"].concat(Array.prototype.slice.call(arguments)));
  }

  function normalizeBaseUrl(url) {
    return String(url || "").replace(/\/$/, "");
  }

  function normalizeShopDomain(domain) {
    return String(domain || "")
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\//, "")
      .replace(/\/.*$/, "");
  }

  function getScriptBaseUrl() {
    if (!script || !script.src) return "";
    try {
      return new URL(script.src).origin;
    } catch (error) {
      return "";
    }
  }

  baseUrl = normalizeBaseUrl(baseUrl || getScriptBaseUrl());
  fallbackMode = String(fallbackMode || "alert").toLowerCase();
  productFallbackMode = String(productFallbackMode || "alert").toLowerCase();

  function getShopDomain() {
    if (configuredShop) return normalizeShopDomain(configuredShop);
    if (window.Shopify && window.Shopify.shop) return normalizeShopDomain(window.Shopify.shop);
    return normalizeShopDomain(window.location.hostname);
  }

  function getMerchantId() {
    return String(configuredMerchant || "").trim();
  }

  function getDrawerFeatureStorageKey() {
    return [
      "stackpay.cartDrawer.enabled",
      getShopDomain() || "unknown-shop",
      getMerchantId() || "unknown-merchant",
    ].join(":");
  }

  function writeCachedDrawerFeatureEnabled(enabled) {
    try {
      window.localStorage.setItem(getDrawerFeatureStorageKey(), enabled ? "1" : "0");
    } catch (error) {
      // Cache is only an optimization; never block checkout/cart behavior.
    }
  }

  function applyDrawerFeatureConfig(config) {
    drawerState.config = config || drawerState.config;
    var customization = config && config.customization ? config.customization : null;
    drawerFeatureEnabled = Boolean(
      config && config.ok === true && customization && customization.is_enabled === true,
    );
    drawerFeatureKnown = true;
    writeCachedDrawerFeatureEnabled(drawerFeatureEnabled);
    if (!drawerFeatureEnabled) {
      drawerState.open = false;
      disableStackPayDrawerMode();
    } else {
      scheduleInstallButton();
    }
    return drawerFeatureEnabled;
  }

  function applyCheckoutFeatureStatus(status) {
    checkoutFeatureEnabled = Boolean(status && status.active === true);
    checkoutFeatureKnown = true;
    if (!checkoutFeatureEnabled) {
      drawerFeatureEnabled = false;
      drawerFeatureKnown = true;
      writeCachedDrawerFeatureEnabled(false);
      disableStackPayDrawerMode();
    } else if (drawerFeatureEnabled) {
      scheduleInstallButton();
    }
    return checkoutFeatureEnabled;
  }

  function shouldUseStackPayCheckout() {
    return checkoutFeatureKnown && checkoutFeatureEnabled;
  }

  function shouldUseStackPayDrawer() {
    return shouldUseStackPayCheckout() && drawerFeatureKnown && drawerFeatureEnabled;
  }

  function restoreNativeTarget(target) {
    if (!target || !target.dataset) return;

    if (target.dataset.stackpayOriginalDisplay != null) {
      target.style.removeProperty("display");
      if (target.dataset.stackpayOriginalDisplay) {
        target.style.display = target.dataset.stackpayOriginalDisplay;
      }
      delete target.dataset.stackpayOriginalDisplay;
    }

    if (target.dataset.stackpayOriginalAriaHidden != null) {
      if (target.dataset.stackpayOriginalAriaHidden) {
        target.setAttribute("aria-hidden", target.dataset.stackpayOriginalAriaHidden);
      } else {
        target.removeAttribute("aria-hidden");
      }
      delete target.dataset.stackpayOriginalAriaHidden;
    }

    if (target.dataset.stackpayOriginalTabindex != null) {
      if (target.dataset.stackpayOriginalTabindex) {
        target.setAttribute("tabindex", target.dataset.stackpayOriginalTabindex);
      } else {
        target.removeAttribute("tabindex");
      }
      delete target.dataset.stackpayOriginalTabindex;
    }

    delete target.dataset.stackpayHidden;
    delete target.dataset.stackpayBound;
  }

  function removeStackPayButtonsAndRestoreNativeTargets() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-stackpay-button="1"]'))
      .forEach(function (button) {
        if (button.parentNode) button.parentNode.removeChild(button);
      });

    Array.prototype.slice
      .call(document.querySelectorAll('[data-stackpay-hidden="1"], [data-stackpay-bound="1"]'))
      .forEach(restoreNativeTarget);

    activeButton = null;
  }

  function removeStackPayDrawerElements() {
    document.documentElement.classList.remove("stackpay-cart-lock");
    document.body.classList.remove("stackpay-cart-lock");

    if (drawerElements) {
      if (drawerElements.overlay && drawerElements.overlay.parentNode) {
        drawerElements.overlay.parentNode.removeChild(drawerElements.overlay);
      }
      if (drawerElements.drawer && drawerElements.drawer.parentNode) {
        drawerElements.drawer.parentNode.removeChild(drawerElements.drawer);
      }
      if (drawerElements.customStyle && drawerElements.customStyle.parentNode) {
        drawerElements.customStyle.parentNode.removeChild(drawerElements.customStyle);
      }
      drawerElements = null;
    }

    var style = document.getElementById("stackpay-cart-drawer-style");
    if (style && style.parentNode) style.parentNode.removeChild(style);

    var customStyle = document.getElementById("stackpay-cart-drawer-custom-style");
    if (customStyle && customStyle.parentNode) customStyle.parentNode.removeChild(customStyle);

    drawerState.open = false;
    drawerState.loading = false;
    drawerState.error = null;
  }

  function disableStackPayDrawerMode() {
    removeStackPayDrawerElements();
    removeStackPayButtonsAndRestoreNativeTargets();
  }

  function isStackPaySurfaceElement(target) {
    return Boolean(
      target &&
      target.closest &&
      target.closest(
        [
          ".stackpay-cart-drawer",
          ".stackpay-cart-overlay",
          "[data-stackpay-surface]",
          "[data-stackpay-button='1']",
        ].join(","),
      ),
    );
  }

  function parseUrl(value) {
    try {
      return new URL(value || "", window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function getPathname(value) {
    var url = parseUrl(value);
    return url ? url.pathname.replace(/\/$/, "") || "/" : "";
  }

  function isPathSegment(pathname, segment) {
    var parts = String(pathname || "")
      .split("/")
      .filter(Boolean);
    return parts[parts.length - 1] === segment;
  }

  function isCheckoutUrl(value) {
    var pathname = getPathname(value);
    return isPathSegment(pathname, "checkout") || pathname.indexOf("/checkouts/") !== -1;
  }

  function isCartPage() {
    return isPathSegment(window.location.pathname, "cart");
  }

  function isProductPage() {
    return window.location.pathname.indexOf("/products/") !== -1;
  }

  function isCartFormAction(action) {
    return isPathSegment(getPathname(action), "cart");
  }

  function isCartAddFormAction(action) {
    var pathname = getPathname(action);
    return (
      pathname === "/cart/add" ||
      pathname === "/cart/add.js" ||
      /\/cart\/add(?:\.js)?$/.test(pathname)
    );
  }

  function isCartPageUrl(value) {
    return isPathSegment(getPathname(value), "cart");
  }

  function isCartOpenTarget(element) {
    if (!element || element.getAttribute("data-stackpay-ignore") === "1") return false;
    if (isNativeCartControlTarget(element)) return false;
    var href = element.getAttribute("href") || "";
    if (href && isCartPageUrl(href) && !isCheckoutUrl(href)) return true;

    var text = getComparableText(element);
    return Boolean(
      href && /cart|carrinho|bag|sacola/i.test(text) && !/checkout|pagamento|payment/i.test(text),
    );
  }

  function isAddToCartTarget(element) {
    if (!element || element.getAttribute("data-stackpay-ignore") === "1") return false;
    if (isNativeCartControlTarget(element)) return false;
    if (!isSubmitLike(element)) return false;
    if (isDirectBuyTarget(element)) return false;
    var form = findProductFormForElement(element);
    if (!form || !isCartAddFormAction(form.getAttribute("action") || "")) return false;
    if (isCheckoutTarget(element)) return false;
    return true;
  }

  function request(url, options) {
    var headers = Object.assign({ Accept: "application/json" }, (options && options.headers) || {});
    var fetchOptions = Object.assign({}, options || {}, { headers: headers });
    log("request", url);
    return fetch(url, fetchOptions).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          if (!response.ok) {
            var error = new Error(body && body.error ? body.error : "Erro na requisicao.");
            error.code = body && body.code ? body.code : "request_failed";
            error.status = response.status;
            error.body = body;
            throw error;
          }
          return body;
        });
    });
  }

  function postJson(url, payload) {
    return request(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: JSON.stringify(payload),
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatMoney(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: currency || "BRL",
      });
    } catch (error) {
      return "R$ " + value.toFixed(2).replace(".", ",");
    }
  }

  function numberValue(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeImageUrl(url) {
    if (!url) return "";
    var value = String(url);
    if (value.indexOf("//") === 0) return window.location.protocol + value;
    return value;
  }

  function getCartItemImage(item) {
    if (item && item.featured_image && item.featured_image.url) {
      return normalizeImageUrl(item.featured_image.url);
    }
    if (item && item.image) return normalizeImageUrl(item.image);
    return "";
  }

  function getCartLineKey(item) {
    if (!item) return "";
    return String(item.key || item.variant_id || item.id || "");
  }

  function getCartItemLinePrice(item) {
    if (!item) return 0;
    return numberValue(item.final_line_price, numberValue(item.line_price, item.final_price || 0));
  }

  function getElementText(element) {
    if (!element) return "";
    return [
      element.textContent || "",
      element.getAttribute("aria-label") || "",
      element.getAttribute("value") || "",
      element.getAttribute("name") || "",
      element.getAttribute("data-action") || "",
      element.getAttribute("data-cart-action") || "",
      element.getAttribute("data-testid") || "",
    ]
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function stripDiacritics(value) {
    value = String(value || "");
    if (typeof value.normalize !== "function") return value;
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function getComparableText(element) {
    return stripDiacritics(getElementText(element))
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  }

  function toElement(target) {
    if (!target) return null;
    if (target.nodeType === 1) return target;
    return target.parentElement || null;
  }

  function isNativeCartControlTarget(element) {
    if (!element || element.getAttribute("data-stackpay-button") === "1") return false;
    if (isStackPaySurfaceElement(element)) return false;

    var compactText = getComparableText(element);
    if (
      /fechar|close|remover|remove|delete|excluir|diminuir|menos|minus|aumentar|plus|increment|decrement|quantity|quantidade|cartremove|cartupdate|drawerclose|modalclose|continuarcomprando/.test(
        compactText,
      )
    ) {
      return true;
    }

    if (!element.closest) return false;
    return Boolean(
      element.closest(
        [
          "[data-cart-remove]",
          "[data-remove]",
          "[data-cart-close]",
          "[data-drawer-close]",
          "[data-close]",
          "[data-quantity-input]",
          "[data-quantity-selector]",
          "[data-quantity-button]",
          "quantity-input",
          "cart-remove-button",
          ".quantity",
          ".cart-item__quantity",
          ".cart-remove",
          ".cart__remove",
          ".cart-drawer__close",
        ].join(","),
      ),
    );
  }

  function getButtonLabel(target, defaultLabel) {
    if (configuredLabel) return configuredLabel;
    var text = getElementText(target);
    if (/stackpay/i.test(text)) return defaultLabel;
    return text || defaultLabel;
  }

  function setButtonText(button, text) {
    if (!button) return;
    if ((button.tagName || "").toLowerCase() === "input") {
      button.value = text;
      return;
    }
    button.textContent = text;
  }

  function hasCheckoutIntentText(element) {
    var compactText = getComparableText(element);
    return (
      /checkout|checkouts|securecheckout|proceedtocheckout|finalizar|finalizarcompra|finalize|completeorder|fecharpedido|irparapagamento|continuarpagamento|continuarparapagamento|pagamento|payment|pagarpedido|pagaragora/i.test(
        compactText,
      ) ||
      /checkout|check-out|finalizar|finalize|fechar pedido|pagamento|payment|pagar pedido|pagar agora/i.test(
        getElementText(element),
      )
    );
  }

  function hasDirectBuyIntentText(element) {
    return /comprar agora|compre agora|buy now/i.test(getElementText(element));
  }

  function isSubmitLike(element) {
    if (!element) return false;
    var tagName = (element.tagName || "").toLowerCase();
    var type = (element.getAttribute("type") || "").toLowerCase();

    if (tagName === "button") return !type || type === "submit" || type === "button";
    if (tagName === "input") return type === "submit" || type === "button";
    return element.getAttribute("role") === "button";
  }

  function getForm(element) {
    return element ? element.form || (element.closest ? element.closest("form") : null) : null;
  }

  function findProductFormForElement(element) {
    var form = getForm(element);
    if (form && isCartAddFormAction(form.getAttribute("action") || "")) return form;

    if (element && element.closest) {
      var section = element.closest(
        [
          "product-form",
          ".product-form",
          ".product",
          ".product__info-container",
          ".product-card",
          ".product-card-wrapper",
          ".card-wrapper",
          ".grid__item",
          "[data-product-id]",
          "[data-product-handle]",
          "article",
          "li",
          "section",
          "main",
        ].join(","),
      );
      if (section) {
        form = section.querySelector('form[action*="/cart/add"]');
        if (form) return form;
      }
    }

    return document.querySelector('form[action*="/cart/add"]');
  }

  function isCartCheckoutForm(form) {
    if (!form) return false;

    var action = form.getAttribute("action") || "";
    if (isCheckoutUrl(action)) return true;
    if (!isCartFormAction(action)) return false;

    if (form.querySelector('[name="checkout"]')) return true;

    var submitters = Array.prototype.slice.call(
      form.querySelectorAll('button, input[type="submit"], input[type="button"], [role="button"]'),
    );
    return submitters.some(function (submitter) {
      return hasCheckoutIntentText(submitter);
    });
  }

  function isCartContextElement(element) {
    if (isCartPage()) return true;
    if (!element || !element.closest) return false;

    return Boolean(
      element.closest(
        [
          'form[action*="/cart"]',
          "[data-cart-drawer]",
          "[data-cart]",
          "cart-drawer",
          "cart-notification",
          '[id*="CartDrawer"]',
          '[id*="cart-drawer"]',
          '[class*="cart-drawer"]',
          '[class*="drawer"]',
          '[id*="cart"]',
          '[class*="cart"]',
        ].join(","),
      ),
    );
  }

  function isCheckoutTarget(element) {
    if (!element) return false;
    if (element.getAttribute("data-stackpay-ignore") === "1") return false;
    if (element.getAttribute("data-stackpay-button") === "1") return true;

    var name = (element.getAttribute("name") || "").toLowerCase();
    var href = element.getAttribute("href") || "";
    var form = getForm(element);
    var formAction = form ? form.getAttribute("action") || "" : "";

    if (name === "checkout") return true;
    if (href && isCheckoutUrl(href)) return true;
    if (formAction && isCheckoutUrl(formAction)) return true;
    if (isSubmitLike(element) && isCartCheckoutForm(form) && hasCheckoutIntentText(element)) {
      return true;
    }
    if (isCartPage() && isSubmitLike(element) && hasCheckoutIntentText(element)) return true;
    if (isSubmitLike(element) && isCartContextElement(element) && hasCheckoutIntentText(element)) {
      return true;
    }

    return false;
  }

  function isDirectBuyTarget(element) {
    if (!element || element.getAttribute("data-stackpay-ignore") === "1") return false;
    if (isProductPage() && element.getAttribute("data-stackpay-button") === "1") {
      return Boolean(findProductFormForElement(element));
    }
    if (isProductPage() && /stackpay/i.test(getElementText(element))) {
      return Boolean(findProductFormForElement(element));
    }
    if (element.getAttribute("data-stackpay-direct-buy") === "1") return true;
    if (!directBuyEnabled || !isSubmitLike(element)) return false;

    var form = findProductFormForElement(element);
    if (!form) return false;
    if (element.closest && element.closest(".shopify-payment-button")) return true;
    return hasDirectBuyIntentText(element);
  }

  function isDirectBuySourceTarget(element) {
    if (!directBuyEnabled || !element) return false;
    if (element.getAttribute("data-stackpay-button") === "1") return false;
    if (!isSubmitLike(element)) return false;
    return isDirectBuyTarget(element);
  }

  function findDirectBuyTargets() {
    if (!directBuyEnabled || !isProductPage()) return [];

    return Array.prototype.slice
      .call(
        document.querySelectorAll(
          'button, input[type="submit"], input[type="button"], [role="button"]',
        ),
      )
      .filter(isDirectBuySourceTarget);
  }

  function findCheckoutTargets() {
    var selectors = [
      'form[action="/cart"] [name="checkout"]',
      'form[action*="/cart"] [name="checkout"]',
      'form[action*="/checkout"] button',
      'form[action*="/checkout"] input[type="submit"]',
      'form[action*="/checkouts"] button',
      'form[action*="/checkouts"] input[type="submit"]',
      'a[href="/checkout"]',
      'a[href$="/checkout"]',
      'a[href*="/checkout?"]',
      'a[href*="/checkouts/"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      "button",
      'input[type="submit"]',
      'input[type="button"]',
      "a[href]",
      '[role="button"]',
    ];

    var seen = [];
    return Array.prototype.slice
      .call(document.querySelectorAll(selectors.join(",")))
      .filter(function (element) {
        if (seen.indexOf(element) !== -1) return false;
        seen.push(element);
        return isCheckoutTarget(element);
      });
  }

  function getProductHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getSelectedVariantId(form, product) {
    var formData = form ? new FormData(form) : null;
    var formVariantId = formData ? formData.get("id") : null;
    var urlVariantId = new URLSearchParams(window.location.search).get("variant");
    var selectedVariantId = String(formVariantId || urlVariantId || "");
    if (selectedVariantId) return selectedVariantId;

    var availableVariant = (product.variants || []).find(function (variant) {
      return variant.available !== false;
    });
    return String((availableVariant || product.variants[0] || {}).id || "");
  }

  function getSelectedQuantity(form) {
    var formData = form ? new FormData(form) : null;
    var value = formData ? formData.get("quantity") : null;
    var quantity = Number(value || 1);
    if (!Number.isFinite(quantity) || quantity <= 0) return 1;
    return Math.max(1, Math.floor(quantity));
  }

  function loadProductJson() {
    var handle = getProductHandleFromPath();
    if (!handle) return Promise.reject(new Error("Produto Shopify nao identificado."));
    if (productCache[handle]) return Promise.resolve(productCache[handle]);

    return request("/products/" + encodeURIComponent(handle) + ".js", {
      method: "GET",
      credentials: "same-origin",
    }).then(function (product) {
      productCache[handle] = product;
      return product;
    });
  }

  function buildProductCheckoutPayload(form) {
    return loadProductJson().then(function (product) {
      var variantId = getSelectedVariantId(form, product);
      var variant = (product.variants || []).find(function (item) {
        return String(item.id) === variantId;
      });

      if (!variant) throw new Error("Variacao selecionada nao encontrada.");
      if (variant.available === false) throw new Error("Variacao selecionada indisponivel.");

      var quantity = getSelectedQuantity(form);
      var image =
        (variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) ||
        product.featured_image ||
        (product.images && product.images[0]) ||
        null;
      var unitPrice = Number(variant.price || 0);

      return {
        token: null,
        currency:
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.currentCurrency) ||
          "BRL",
        total_price: unitPrice * quantity,
        items: [
          {
            id: String(product.id),
            product_id: String(product.id),
            variant_id: String(variant.id),
            sku: variant.sku || null,
            title: product.title,
            product_title: product.title,
            quantity: quantity,
            price: unitPrice,
            final_price: unitPrice,
            image: image,
            featured_image: image ? { url: image } : null,
          },
        ],
      };
    });
  }

  function getDrawerCustomization() {
    var remote =
      drawerState.config && drawerState.config.customization
        ? drawerState.config.customization
        : {};
    return Object.assign({}, DEFAULT_DRAWER_CUSTOMIZATION, remote || {});
  }

  function getDrawerRecommendations() {
    return drawerState.config && drawerState.config.recommendations
      ? drawerState.config.recommendations
      : { order_bumps: [], gifts: [] };
  }

  function ensureDrawerElements() {
    if (drawerElements) return drawerElements;

    var style = document.createElement("style");
    style.id = "stackpay-cart-drawer-style";
    style.textContent =
      ".stackpay-cart-lock{overflow:hidden!important}" +
      ".stackpay-cart-overlay{position:fixed;inset:0;z-index:2147483646;display:none;background:rgba(7,16,11,.48);backdrop-filter:blur(4px)}" +
      ".stackpay-cart-overlay[data-open='1']{display:block}" +
      ".stackpay-cart-drawer{position:fixed;right:0;top:0;z-index:2147483647;height:100vh;width:min(100%,430px);display:flex;flex-direction:column;box-shadow:-28px 0 80px -48px rgba(0,0,0,.65);transform:translateX(104%);transition:transform .24s ease}" +
      ".stackpay-cart-drawer[data-open='1']{transform:translateX(0)}" +
      ".stackpay-cart-header{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:22px;border-bottom:1px solid rgba(15,23,42,.1)}" +
      ".stackpay-cart-title{margin:0;font-size:22px;line-height:1.1;font-weight:900;letter-spacing:-.04em}" +
      ".stackpay-cart-subtitle{margin:6px 0 0;font-size:13px;line-height:1.45;opacity:.68}" +
      ".stackpay-cart-close{border:1px solid rgba(15,23,42,.12);background:rgba(255,255,255,.72);width:40px;height:40px;border-radius:999px;font-size:24px;line-height:1;cursor:pointer}" +
      ".stackpay-cart-body{flex:1;overflow:auto;padding:18px 22px}" +
      ".stackpay-cart-loading,.stackpay-cart-empty,.stackpay-cart-error{display:flex;min-height:220px;align-items:center;justify-content:center;text-align:center;font-weight:700;opacity:.72}" +
      ".stackpay-cart-progress{margin-bottom:16px;border:1px solid rgba(15,23,42,.08);padding:12px;background:rgba(15,23,42,.035)}" +
      ".stackpay-cart-progress-row{display:flex;align-items:center;justify-content:space-between;font-size:12px;font-weight:800}" +
      ".stackpay-cart-progress-track{height:8px;margin-top:9px;border-radius:999px;background:rgba(15,23,42,.1);overflow:hidden}" +
      ".stackpay-cart-progress-bar{height:100%;border-radius:999px}" +
      ".stackpay-cart-progress-hint{margin:8px 0 0;font-size:11px;opacity:.68}" +
      ".stackpay-cart-items{display:grid;gap:12px}" +
      ".stackpay-cart-item{display:grid;grid-template-columns:72px 1fr auto;gap:12px;align-items:center;border-bottom:1px solid rgba(15,23,42,.08);padding-bottom:12px}" +
      ".stackpay-cart-image{width:72px;height:72px;border-radius:16px;object-fit:cover;background:rgba(15,23,42,.06)}" +
      ".stackpay-cart-item-title{margin:0;font-size:13px;font-weight:850;line-height:1.3}" +
      ".stackpay-cart-item-variant{margin:4px 0 0;font-size:11px;opacity:.58}" +
      ".stackpay-cart-qty{display:inline-flex;align-items:center;margin-top:10px;border:1px solid rgba(15,23,42,.16);border-radius:12px;overflow:hidden}" +
      ".stackpay-cart-qty button{width:30px;height:30px;border:0;background:transparent;cursor:pointer;font-size:16px}" +
      ".stackpay-cart-qty span{min-width:30px;text-align:center;font-size:12px;font-weight:800}" +
      ".stackpay-cart-price{font-size:13px;font-weight:900;white-space:nowrap}" +
      ".stackpay-cart-section{margin-top:18px;border-radius:18px;background:rgba(15,23,42,.045);padding:12px}" +
      ".stackpay-cart-section-title{margin:0 0 10px;font-size:10px;font-weight:950;text-transform:uppercase;letter-spacing:.16em}" +
      ".stackpay-cart-bump{display:grid;grid-template-columns:58px 1fr;gap:12px;align-items:center;border-radius:14px;background:rgba(255,255,255,.75);padding:10px}" +
      ".stackpay-cart-bump+.stackpay-cart-bump{margin-top:8px}" +
      ".stackpay-cart-bump img{width:58px;height:58px;border-radius:12px;object-fit:cover;background:rgba(15,23,42,.06)}" +
      ".stackpay-cart-bump-title{margin:0;font-size:12px;font-weight:900}" +
      ".stackpay-cart-bump-description{margin:3px 0 0;font-size:11px;opacity:.62}" +
      ".stackpay-cart-bump-price{margin-top:5px;font-size:12px;font-weight:900}" +
      ".stackpay-cart-bump-price s{margin-right:5px;opacity:.55;font-weight:600}" +
      ".stackpay-cart-bump-button{margin-top:8px;width:100%;height:34px;border:0;border-radius:12px;font-size:11px;font-weight:900;cursor:pointer}" +
      ".stackpay-cart-gift{display:flex;gap:10px;align-items:center;border-radius:14px;background:rgba(255,255,255,.75);padding:10px}" +
      ".stackpay-cart-gift img{width:46px;height:46px;border-radius:12px;object-fit:cover;background:rgba(15,23,42,.06)}" +
      ".stackpay-cart-gift strong{display:block;font-size:12px}" +
      ".stackpay-cart-gift span{display:block;margin-top:2px;font-size:11px;opacity:.62}" +
      ".stackpay-cart-footer{border-top:1px solid rgba(15,23,42,.1);padding:18px 22px 20px}" +
      ".stackpay-cart-total{display:flex;align-items:center;justify-content:space-between;font-size:16px;font-weight:900}" +
      ".stackpay-cart-checkout{margin-top:14px;width:100%;height:52px;border:0;border-radius:14px;font-weight:950;text-transform:uppercase;letter-spacing:.14em;cursor:pointer}" +
      ".stackpay-cart-continue{margin-top:9px;width:100%;height:40px;border:0;background:transparent;font-weight:800;cursor:pointer;opacity:.72}" +
      "@media(max-width:520px){.stackpay-cart-drawer{width:100%}.stackpay-cart-header{padding:20px}.stackpay-cart-body{padding:16px 18px}.stackpay-cart-footer{padding:16px 18px 18px}}";
    document.head.appendChild(style);

    var customStyle = document.createElement("style");
    customStyle.id = "stackpay-cart-drawer-custom-style";
    document.head.appendChild(customStyle);

    var overlay = document.createElement("button");
    overlay.type = "button";
    overlay.className = "stackpay-cart-overlay";
    overlay.setAttribute("aria-label", "Fechar carrinho");
    overlay.setAttribute("data-stackpay-surface", "cart-overlay");
    overlay.setAttribute("data-stackpay-ignore", "1");
    overlay.addEventListener("click", closeStackPayDrawer);
    document.body.appendChild(overlay);

    var drawer = document.createElement("aside");
    drawer.className = "stackpay-cart-drawer";
    drawer.setAttribute("data-stackpay-surface", "cart-drawer");
    drawer.setAttribute("data-stackpay-ignore", "1");
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-label", "Carrinho StackPay");
    drawer.addEventListener(
      "pointerdown",
      function (event) {
        if (!isStackPaySurfaceElement(event.target)) return;
        event.stopPropagation();
      },
      true,
    );
    drawer.addEventListener("click", handleDrawerClick, true);
    document.body.appendChild(drawer);

    drawerElements = {
      overlay: overlay,
      drawer: drawer,
      customStyle: customStyle,
    };

    return drawerElements;
  }

  function applyDrawerTheme() {
    var elements = ensureDrawerElements();
    var customization = getDrawerCustomization();
    elements.drawer.style.backgroundColor = customization.background_color;
    elements.drawer.style.color = customization.text_color;
    elements.drawer.style.borderTopLeftRadius = String(customization.border_radius) + "px";
    elements.drawer.style.borderBottomLeftRadius = String(customization.border_radius) + "px";
    elements.customStyle.textContent = customization.custom_css || "";
  }

  function loadShopifyCart() {
    return request("/cart.js", { method: "GET", credentials: "same-origin" });
  }

  function getVariantIdFromForm(form) {
    if (!form) return "";
    var field = form.querySelector('[name="id"]');
    return field && field.value ? String(field.value) : "";
  }

  function getVariantIdFromCartAddResponse(response, form) {
    var item =
      response && Array.isArray(response.items) && response.items.length
        ? response.items[0]
        : response;
    return String((item && (item.variant_id || item.id)) || getVariantIdFromForm(form) || "");
  }

  function cartHasExpectedItem(cart, expected) {
    if (!expected) return true;

    var items = (cart && cart.items) || [];
    var variantId = expected.variantId ? String(expected.variantId) : "";
    if (variantId) {
      return items.some(function (item) {
        return String(item.variant_id || item.id || "") === variantId;
      });
    }

    if (expected.minItemCount != null) {
      return numberValue(cart && cart.item_count, 0) >= expected.minItemCount;
    }

    return true;
  }

  function loadShopifyCartWithRetry(expected, attempt) {
    return loadShopifyCart().then(function (cart) {
      if (cartHasExpectedItem(cart, expected) || attempt >= 6) return cart;

      return wait(140 + attempt * 60).then(function () {
        return loadShopifyCartWithRetry(expected, attempt + 1);
      });
    });
  }

  function fetchDrawerConfig(cartPayload) {
    var payload = {
      shop: getShopDomain(),
      cart_payload: cartPayload || { items: [], total_price: 0 },
    };
    var merchantId = getMerchantId();
    if (merchantId) payload.merchant_id = merchantId;

    return postJson(normalizeBaseUrl(baseUrl) + "/api/public/shopify/cart-drawer", payload).catch(
      function (error) {
        log("drawer config fallback", error);
        return {
          ok: false,
          customization: DEFAULT_DRAWER_CUSTOMIZATION,
          recommendations: { order_bumps: [], gifts: [] },
        };
      },
    );
  }

  function renderProgress(cart, customization) {
    if (
      !customization.show_free_shipping_progress ||
      !customization.free_shipping_threshold_cents
    ) {
      return "";
    }

    var total = numberValue(cart.total_price, 0);
    var threshold = numberValue(customization.free_shipping_threshold_cents, 0);
    if (!threshold) return "";
    var progress = Math.min(100, Math.round((total / threshold) * 100));
    var missing = Math.max(0, threshold - total);

    return (
      '<section class="stackpay-cart-progress" style="border-radius:' +
      escapeHtml(customization.border_radius) +
      'px">' +
      '<div class="stackpay-cart-progress-row"><span>🚚 Frete gratis</span><span>' +
      progress +
      "%</span></div>" +
      '<div class="stackpay-cart-progress-track"><div class="stackpay-cart-progress-bar" style="width:' +
      progress +
      "%;background:" +
      escapeHtml(customization.button_color) +
      '"></div></div>' +
      '<p class="stackpay-cart-progress-hint">' +
      (missing > 0
        ? "Faltam " + formatMoney(missing, cart.currency) + " para liberar frete gratis."
        : "Voce desbloqueou frete gratis.") +
      "</p></section>"
    );
  }

  function renderCartItems(cart, customization) {
    var items = cart.items || [];
    if (!items.length) {
      return (
        '<div class="stackpay-cart-empty">' + escapeHtml(customization.empty_cart_text) + "</div>"
      );
    }

    return (
      '<div class="stackpay-cart-items">' +
      items
        .map(function (item) {
          var key = getCartLineKey(item);
          var image = getCartItemImage(item);
          var quantity = numberValue(item.quantity, 1);
          var variant =
            item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
          return (
            '<article class="stackpay-cart-item">' +
            (image
              ? '<img class="stackpay-cart-image" alt="" src="' + escapeHtml(image) + '">'
              : '<div class="stackpay-cart-image"></div>') +
            "<div>" +
            '<p class="stackpay-cart-item-title" style="color:' +
            escapeHtml(customization.primary_color) +
            '">' +
            escapeHtml(item.product_title || item.title || "Produto") +
            "</p>" +
            (variant
              ? '<p class="stackpay-cart-item-variant">' + escapeHtml(variant) + "</p>"
              : "") +
            '<div class="stackpay-cart-qty" aria-label="Quantidade">' +
            '<button type="button" data-stackpay-qty="-1" data-stackpay-line="' +
            escapeHtml(key) +
            '">−</button>' +
            "<span>" +
            quantity +
            "</span>" +
            '<button type="button" data-stackpay-qty="1" data-stackpay-line="' +
            escapeHtml(key) +
            '">+</button></div>' +
            "</div>" +
            '<div class="stackpay-cart-price" style="color:' +
            escapeHtml(customization.primary_color) +
            '">' +
            formatMoney(getCartItemLinePrice(item), cart.currency) +
            "</div></article>"
          );
        })
        .join("") +
      "</div>"
    );
  }

  function renderOrderBumps(cart, customization) {
    if (!customization.show_order_bumps) return "";
    var recommendations = getDrawerRecommendations();
    var bumps = recommendations.order_bumps || [];
    if (!bumps.length) return "";

    return (
      '<section class="stackpay-cart-section">' +
      '<p class="stackpay-cart-section-title" style="color:' +
      escapeHtml(customization.accent_color) +
      '">Oferta especial</p>' +
      bumps
        .map(function (bump) {
          var image = normalizeImageUrl(bump.image_url);
          return (
            '<article class="stackpay-cart-bump">' +
            (image
              ? '<img alt="" src="' + escapeHtml(image) + '">'
              : '<div class="stackpay-cart-image" style="width:58px;height:58px"></div>') +
            "<div>" +
            '<p class="stackpay-cart-bump-title" style="color:' +
            escapeHtml(customization.primary_color) +
            '">' +
            escapeHtml(bump.title) +
            "</p>" +
            (bump.description
              ? '<p class="stackpay-cart-bump-description">' + escapeHtml(bump.description) + "</p>"
              : "") +
            '<p class="stackpay-cart-bump-price">' +
            (bump.compare_at_price_cents
              ? "<s>" + formatMoney(bump.compare_at_price_cents, cart.currency) + "</s>"
              : "") +
            formatMoney(bump.price_cents, cart.currency) +
            "</p>" +
            '<button type="button" class="stackpay-cart-bump-button" data-stackpay-add-variant="' +
            escapeHtml(bump.shopify_variant_id) +
            '" style="background:' +
            escapeHtml(customization.button_color) +
            ';color:#07100B">' +
            escapeHtml(bump.button_text || "Adicionar oferta") +
            "</button></div></article>"
          );
        })
        .join("") +
      "</section>"
    );
  }

  function renderGifts(customization) {
    if (!customization.show_gifts) return "";
    var recommendations = getDrawerRecommendations();
    var gifts = recommendations.gifts || [];
    if (!gifts.length) return "";

    return (
      '<section class="stackpay-cart-section">' +
      '<p class="stackpay-cart-section-title" style="color:' +
      escapeHtml(customization.accent_color) +
      '">Brinde liberado</p>' +
      gifts
        .map(function (gift) {
          var image = normalizeImageUrl(gift.image_url);
          return (
            '<article class="stackpay-cart-gift">' +
            (image
              ? '<img alt="" src="' + escapeHtml(image) + '">'
              : '<div class="stackpay-cart-image" style="width:46px;height:46px"></div>') +
            '<div><strong style="color:' +
            escapeHtml(customization.primary_color) +
            '">' +
            escapeHtml(gift.gift_name || gift.name || "Brinde especial") +
            "</strong><span>" +
            escapeHtml(gift.message || "Aplicado no checkout quando a regra estiver valida.") +
            "</span></div></article>"
          );
        })
        .join("") +
      "</section>"
    );
  }

  function renderDrawer() {
    var elements = ensureDrawerElements();
    applyDrawerTheme();

    var customization = getDrawerCustomization();
    var cart = drawerState.cart || { items: [], item_count: 0, total_price: 0, currency: "BRL" };
    var body = "";

    if (drawerState.loading) {
      body = '<div class="stackpay-cart-loading">Carregando carrinho...</div>';
    } else if (drawerState.error) {
      body =
        '<div class="stackpay-cart-error">' +
        escapeHtml(drawerState.error) +
        "<br><small>Tente novamente ou finalize pelo checkout.</small></div>";
    } else {
      body =
        renderProgress(cart, customization) +
        renderCartItems(cart, customization) +
        renderOrderBumps(cart, customization) +
        renderGifts(customization);
    }

    elements.drawer.innerHTML =
      '<header class="stackpay-cart-header">' +
      "<div>" +
      '<h2 class="stackpay-cart-title" style="color:' +
      escapeHtml(customization.primary_color) +
      '">' +
      escapeHtml(customization.title) +
      "</h2>" +
      '<p class="stackpay-cart-subtitle">' +
      escapeHtml(customization.subtitle) +
      "</p></div>" +
      '<button type="button" class="stackpay-cart-close" data-stackpay-close-cart data-stackpay-ignore="1" aria-label="Fechar carrinho">×</button>' +
      "</header>" +
      '<main class="stackpay-cart-body">' +
      body +
      "</main>" +
      '<footer class="stackpay-cart-footer">' +
      '<div class="stackpay-cart-total"><span>Total estimado</span><strong style="color:' +
      escapeHtml(customization.primary_color) +
      '">' +
      formatMoney(cart.total_price, cart.currency) +
      "</strong></div>" +
      '<button type="button" class="stackpay-cart-checkout" data-stackpay-drawer-checkout data-stackpay-ignore="1" style="background:' +
      escapeHtml(customization.button_color) +
      ";color:#07100B;border-radius:" +
      Math.max(10, numberValue(customization.border_radius, 16)) +
      'px">' +
      escapeHtml(customization.checkout_button_text) +
      "</button>" +
      '<button type="button" class="stackpay-cart-continue" data-stackpay-close-cart data-stackpay-ignore="1">' +
      escapeHtml(customization.continue_shopping_text) +
      "</button></footer>";
  }

  function setDrawerOpen(open) {
    var elements = ensureDrawerElements();
    drawerState.open = open;
    elements.overlay.setAttribute("data-open", open ? "1" : "0");
    elements.drawer.setAttribute("data-open", open ? "1" : "0");
    document.documentElement.classList.toggle("stackpay-cart-lock", open);
    document.body.classList.toggle("stackpay-cart-lock", open);
  }

  function closeStackPayDrawer() {
    setDrawerOpen(false);
  }

  function refreshStackPayDrawer(expected) {
    drawerState.loading = true;
    drawerState.error = null;
    renderDrawer();

    return loadShopifyCartWithRetry(expected, 0)
      .then(function (cart) {
        drawerState.cart = cart;
        return fetchDrawerConfig(cart).then(function (config) {
          if (!applyDrawerFeatureConfig(config) && drawerState.open) {
            drawerState.loading = false;
            closeStackPayDrawer();
            window.location.href = "/cart";
            return cart;
          }
          drawerState.loading = false;
          renderDrawer();
          return cart;
        });
      })
      .catch(function (error) {
        drawerState.loading = false;
        drawerState.error =
          error && error.message ? error.message : "Nao foi possivel carregar o carrinho.";
        renderDrawer();
        throw error;
      });
  }

  function openStackPayDrawer(expected) {
    if (!shouldUseStackPayDrawer()) {
      window.location.href = "/cart";
      return Promise.resolve();
    }

    setDrawerOpen(true);
    renderDrawer();
    return refreshStackPayDrawer(expected);
  }

  function changeCartQuantity(lineKey, delta) {
    var items = (drawerState.cart && drawerState.cart.items) || [];
    var item = items.find(function (cartItem) {
      return getCartLineKey(cartItem) === String(lineKey);
    });
    if (!item) return Promise.resolve();

    var nextQuantity = Math.max(0, numberValue(item.quantity, 1) + delta);
    drawerState.loading = true;
    renderDrawer();

    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: lineKey, quantity: nextQuantity }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Nao foi possivel atualizar o carrinho.");
        return refreshStackPayDrawer();
      })
      .catch(function (error) {
        drawerState.loading = false;
        drawerState.error = error && error.message ? error.message : "Erro no carrinho.";
        renderDrawer();
      });
  }

  function addVariantToCart(variantId) {
    if (!variantId) return Promise.resolve();
    drawerState.loading = true;
    renderDrawer();

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Nao foi possivel adicionar a oferta.");
        return refreshStackPayDrawer();
      })
      .catch(function (error) {
        drawerState.loading = false;
        drawerState.error = error && error.message ? error.message : "Erro no carrinho.";
        renderDrawer();
      });
  }

  function handleDrawerClick(event) {
    var target = toElement(event.target);
    if (!target) return;

    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var close = target.closest ? target.closest("[data-stackpay-close-cart]") : null;
    if (close) {
      event.preventDefault();
      closeStackPayDrawer();
      return;
    }

    var checkout = target.closest ? target.closest("[data-stackpay-drawer-checkout]") : null;
    if (checkout) {
      event.preventDefault();
      activeButton = checkout;
      redirectToStackPay();
      return;
    }

    var quantity = target.closest ? target.closest("[data-stackpay-qty]") : null;
    if (quantity) {
      event.preventDefault();
      changeCartQuantity(
        quantity.getAttribute("data-stackpay-line"),
        Number(quantity.dataset.stackpayQty),
      );
      return;
    }

    var addVariant = target.closest ? target.closest("[data-stackpay-add-variant]") : null;
    if (addVariant) {
      event.preventDefault();
      addVariantToCart(addVariant.getAttribute("data-stackpay-add-variant"));
    }
  }

  function addProductToCartAndOpenDrawer(element) {
    var form = findProductFormForElement(element);
    if (!form || !isCartAddFormAction(form.getAttribute("action") || "")) {
      openStackPayDrawer();
      return;
    }

    activeButton = element;
    setLoading(true);
    fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Nao foi possivel adicionar o produto ao carrinho.");
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function (addedItem) {
        var expectedVariantId = getVariantIdFromCartAddResponse(addedItem, form);
        setLoading(false);
        openStackPayDrawer({ variantId: expectedVariantId, minItemCount: 1 });
      })
      .catch(function (error) {
        setLoading(false);
        alert(getRedirectErrorMessage(error));
      });
  }

  function setLoading(loading) {
    var buttons = Array.prototype.slice.call(
      document.querySelectorAll('[data-stackpay-button="1"]'),
    );
    if (activeButton && buttons.indexOf(activeButton) === -1) buttons.push(activeButton);

    buttons.forEach(function (button) {
      if ("disabled" in button) button.disabled = loading;
      if (button.dataset) button.dataset.loading = loading ? "1" : "0";
      button.setAttribute("aria-busy", loading ? "true" : "false");
      if (button.getAttribute("data-stackpay-button") === "1") {
        setButtonText(
          button,
          loading
            ? "Redirecionando..."
            : button.getAttribute("data-stackpay-label") || "Finalizar compra",
        );
      }
    });
  }

  function redirectToNativeCheckout(error) {
    log("native fallback", {
      code: error && error.code,
      message: error && error.message,
      url: nativeCheckoutUrl,
    });
    window.location.href = nativeCheckoutUrl;
  }

  function shouldFallbackToNativeCheckout(error) {
    var code = error && error.code ? String(error.code) : "";
    return code === "store_not_connected" || code === "origin_not_allowed";
  }

  function getRedirectErrorMessage(error) {
    var message =
      error && error.message ? error.message : "Nao foi possivel abrir o checkout StackPay.";
    if (error && error.code && error.code !== "request_failed") {
      return message + " [" + error.code + "]";
    }
    return message;
  }

  function handleRedirectError(error) {
    redirecting = false;
    setLoading(false);
    log("redirect failed", error);

    if (shouldFallbackToNativeCheckout(error)) {
      redirectToNativeCheckout(error);
      return;
    }

    var action = activeButton ? activeButton.getAttribute("data-stackpay-action") || "" : "";
    var isProductCheckout =
      action === "direct_buy" ||
      (activeButton && isProductPage() && /stackpay/i.test(getElementText(activeButton)));

    if (isProductCheckout && productFallbackMode !== "native") {
      alert(getRedirectErrorMessage(error));
      return;
    }

    if (fallbackMode === "native") {
      redirectToNativeCheckout(error);
      return;
    }

    if (fallbackMode === "alert") {
      alert(getRedirectErrorMessage(error));
    }
  }

  function openStackPayCheckout(cartPayload) {
    var payload = {
      shop: getShopDomain(),
      cart_payload: cartPayload,
    };
    var merchantId = getMerchantId();
    if (merchantId) payload.merchant_id = merchantId;

    return postJson(
      normalizeBaseUrl(baseUrl) + "/api/public/shopify/cart-to-checkout",
      payload,
    ).then(function (response) {
      if (!response.checkout_url) {
        throw new Error("Checkout StackPay indisponivel.");
      }
      log("redirect checkout", response.checkout_url);
      window.location.href = response.checkout_url;
    });
  }

  function redirectToStackPay() {
    if (redirecting) return;
    redirecting = true;
    log("redirect start", { shop: getShopDomain(), merchantId: getMerchantId(), baseUrl: baseUrl });
    setLoading(true);

    request("/cart.js", { method: "GET", credentials: "same-origin" })
      .then(openStackPayCheckout)
      .catch(handleRedirectError);
  }

  function addProductToCartAndRedirect(element) {
    if (redirecting) return;
    var form = findProductFormForElement(element);
    if (!form || !isCartAddFormAction(form.getAttribute("action") || "")) {
      activeButton = element;
      redirectToStackPay();
      return;
    }

    activeButton = element;
    redirecting = true;
    setLoading(true);
    log("direct buy add", form.getAttribute("action"));

    fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Nao foi possivel adicionar o produto ao carrinho.");
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        redirecting = false;
        redirectToStackPay();
      })
      .catch(handleRedirectError);
  }

  function redirectProductToStackPay(element) {
    if (redirecting) return;

    var form = findProductFormForElement(element);
    activeButton = element;
    redirecting = true;
    setLoading(true);
    log("product checkout start");

    buildProductCheckoutPayload(form).then(openStackPayCheckout).catch(handleRedirectError);
  }

  function createStackPayButton(target, action) {
    var button = document.createElement("button");
    var label = getButtonLabel(
      target,
      action === "direct_buy" ? "Comprar agora" : "Finalizar compra",
    );
    button.type = "button";
    button.className = target.className || "";
    button.setAttribute("data-stackpay-button", "1");
    button.setAttribute("data-stackpay-action", action);
    button.setAttribute("data-stackpay-label", label);
    button.setAttribute("aria-label", target.getAttribute("aria-label") || label);
    setButtonText(button, label);
    button.addEventListener("click", function (event) {
      event.preventDefault();
      activeButton = button;
      if (action === "direct_buy") {
        redirectProductToStackPay(button);
        return;
      }
      redirectToStackPay();
    });
    return button;
  }

  function hideNativeTarget(target) {
    if (!target) return;
    if (target.dataset && !target.dataset.stackpayOriginalDisplay) {
      target.dataset.stackpayOriginalDisplay = target.style.display || "";
    }
    if (target.dataset && target.dataset.stackpayOriginalAriaHidden == null) {
      target.dataset.stackpayOriginalAriaHidden = target.getAttribute("aria-hidden") || "";
    }
    if (target.dataset && target.dataset.stackpayOriginalTabindex == null) {
      target.dataset.stackpayOriginalTabindex = target.getAttribute("tabindex") || "";
    }
    if (target.dataset) target.dataset.stackpayHidden = "1";
    target.setAttribute("aria-hidden", "true");
    target.setAttribute("tabindex", "-1");
    target.style.setProperty("display", "none", "important");
  }

  function getInstallRoot(target, action) {
    var form = getForm(target);
    if (form) return form;

    if (target && target.closest && action === "checkout") {
      return (
        target.closest(
          [
            "[data-cart-drawer]",
            "cart-drawer",
            "cart-notification",
            '[id*="CartDrawer"]',
            '[id*="cart-drawer"]',
            '[class*="cart-drawer"]',
            '[class*="drawer"]',
            '[id*="cart"]',
            '[class*="cart"]',
          ].join(","),
        ) ||
        target.parentElement ||
        document.body
      );
    }

    return (target && target.parentElement) || document.body;
  }

  function findExistingStackPayButton(root, action) {
    if (!root || !root.querySelector) return null;

    return root.querySelector('[data-stackpay-button="1"][data-stackpay-action="' + action + '"]');
  }

  function installButton() {
    if (!shouldUseStackPayDrawer()) return;

    var targets = findCheckoutTargets().map(function (target) {
      return { element: target, action: "checkout" };
    });
    var directTargets = findDirectBuyTargets().map(function (target) {
      return { element: target, action: "direct_buy" };
    });

    targets = targets.concat(directTargets);
    log("install targets", targets.length);
    if (!targets.length) return;

    targets.forEach(function (targetInfo) {
      var target = targetInfo.element;
      if (target.getAttribute("data-stackpay-button") === "1") return;
      var installRoot = getInstallRoot(target, targetInfo.action);
      var existingButton = findExistingStackPayButton(installRoot, targetInfo.action);

      if (existingButton) {
        hideNativeTarget(target);
        target.setAttribute("data-stackpay-bound", "1");
        if (!activeButton) activeButton = existingButton;
        return;
      }

      if (target.getAttribute("data-stackpay-bound") === "1") {
        hideNativeTarget(target);
        return;
      }

      target.setAttribute("data-stackpay-bound", "1");
      hideNativeTarget(target);
      var button = createStackPayButton(target, targetInfo.action);
      target.insertAdjacentElement("afterend", button);
      if (!activeButton) activeButton = button;
    });
  }

  function closestActionElement(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'a[href], button, input[type="submit"], input[type="button"], [role="button"]',
    );
  }

  function interceptActionClick(event) {
    if (isStackPaySurfaceElement(event.target)) return;

    var element = closestActionElement(event.target);
    if (isDirectBuyTarget(element)) {
      if (!shouldUseStackPayCheckout()) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      redirectProductToStackPay(element);
      return;
    }

    if (isAddToCartTarget(element)) {
      if (!shouldUseStackPayDrawer()) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      addProductToCartAndOpenDrawer(element);
      return;
    }

    if (isCartOpenTarget(element)) {
      if (!shouldUseStackPayDrawer()) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openStackPayDrawer();
      return;
    }

    if (!isCheckoutTarget(element)) return;
    if (!shouldUseStackPayCheckout()) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    activeButton = element;
    redirectToStackPay();
  }

  function interceptCheckoutSubmit(event) {
    if (isStackPaySurfaceElement(event.target)) return;

    var submitter = event.submitter || document.activeElement;
    var formAction = event.target ? event.target.getAttribute("action") || "" : "";
    var isCheckoutSubmitter = isCheckoutTarget(submitter);
    var isDirectBuySubmitter = isDirectBuyTarget(submitter);
    var isAddToCartSubmitter = isAddToCartTarget(submitter);
    var isCheckoutForm = isCheckoutUrl(formAction);
    var isCartForm = isCartCheckoutForm(event.target);
    var isAddToCartForm = isCartAddFormAction(formAction);

    if (isDirectBuySubmitter) {
      if (!shouldUseStackPayCheckout()) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      redirectProductToStackPay(submitter);
      return;
    }

    if (isAddToCartSubmitter || (!isCheckoutSubmitter && isAddToCartForm)) {
      if (!shouldUseStackPayDrawer()) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      addProductToCartAndOpenDrawer(submitter);
      return;
    }

    if (!isCheckoutSubmitter && !isCheckoutForm && !isCartForm) return;
    if (!shouldUseStackPayCheckout()) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    activeButton = submitter;
    redirectToStackPay();
  }

  function scheduleInstallButton() {
    if (observerTimer) window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(installButton, 100);
  }

  function exposeDebugApi() {
    window.StackPayCheckout = {
      getShopDomain: getShopDomain,
      findCheckoutTargets: findCheckoutTargets,
      installButton: installButton,
      __loaded: true,
      redirectToStackPay: redirectToStackPay,
      openDrawer: openStackPayDrawer,
      closeDrawer: closeStackPayDrawer,
      refreshDrawer: refreshStackPayDrawer,
      config: {
        baseUrl: baseUrl,
        configuredShop: configuredShop,
        configuredMerchant: configuredMerchant,
        debug: debug,
        fallbackMode: fallbackMode,
        productFallbackMode: productFallbackMode,
        nativeCheckoutUrl: nativeCheckoutUrl,
        directBuyEnabled: directBuyEnabled,
        scriptFound: Boolean(script),
        scriptSrc: script ? script.src : "",
      },
    };
  }

  function init() {
    exposeDebugApi();

    if (!baseUrl) {
      console.error("StackPay: informe data-stackpay-base no script.");
      return;
    }

    log("loaded", { shop: getShopDomain(), baseUrl: baseUrl });

    fetchDrawerConfig({ items: [], total_price: 0 })
      .then(applyDrawerFeatureConfig)
      .catch(function (error) {
        log("drawer feature config preload failed", error);
      });

    document.addEventListener("click", interceptActionClick, true);
    document.addEventListener("submit", interceptCheckoutSubmit, true);
    if ("MutationObserver" in window) {
      new MutationObserver(scheduleInstallButton).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    var statusUrl =
      normalizeBaseUrl(baseUrl) +
      "/api/public/shopify/status?shop=" +
      encodeURIComponent(getShopDomain());
    if (getMerchantId()) {
      statusUrl += "&merchant_id=" + encodeURIComponent(getMerchantId());
    }

    request(statusUrl, {
      method: "GET",
      headers: { Accept: "application/json" },
    })
      .then(function (status) {
        applyCheckoutFeatureStatus(status);
        log("status", status);
      })
      .catch(function (error) {
        applyCheckoutFeatureStatus({ active: false });
        log("status error", error);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
